import {Fragment, PureComponent} from 'react'
import PayU from 'Component/PayU';
import {formatCurrency} from "Util/Price";
import Image from 'Component/Image';
import Loader from 'Component/Loader';
import './RetryPayuPage.style';

class RetryPayuPage extends PureComponent {

    renderBaseInfo() {
        const { order: { base_order_info } } = this.props;
        const { status_label, created_at } = base_order_info || {};

        return (
            <div>
                <h4>{ __('Order details') }</h4>
                <p>{ __('Created at: ') }{ created_at }</p>
                <p>{ __('Status: ') }{ status_label }</p>
            </div>
        );
    }

    renderAwb() {
        const {
            order: {
                base_order_info: {
                    additional_attributes: {
                        nr_awb,
                        link_awb
                    }
                }
            },
        } = this.props;

        if (!nr_awb) {
            return null;
        }

        if (link_awb) {
            return <p>AWB: <a href={ link_awb } target="_blank">{ nr_awb }</a></p>;
        }

        return <p>AWB: { nr_awb }</p>;
    }

    renderShipping() {
        const {
            order: {
                shipping_info,
                base_order_info: {
                    additional_attributes: {
                        curier
                    }
                }
            },
            currency_code
        } = this.props;

        const {
            shipping_description
        } = shipping_info || {};

        return (
            <div block="RetryPageOrderDetails" elem="ShippingWrapper">
                <h4>{ __('Shipping') }</h4>
                <p>{ `${shipping_description}` }</p>
                { curier && <p>{`${__('Courier')} ${curier}`}</p>}
                { this.renderAwb() }
            </div>
        );
    }

    renderGiftSticker(free_gift_item, qty) {
        const gift_type = free_gift_item.split('_')[0];
        let sticker_msg = '';

        switch(gift_type) {
            case 'order':
            case 'gama':
                if (qty === 1) {
                    sticker_msg = __('gift product')
                } else {
                    sticker_msg = __('of which 1 gift product')
                }
                break;
            case 'one':
                if (qty === 2) {
                    sticker_msg = __('of which 1 gift product')
                } else {
                    sticker_msg = __('of which %s gift products', Math.floor(qty / 2))
                }
                break;
            case 'two':
                const qty_free = Math.floor(qty / 3);
                if (qty_free === 1) {
                    sticker_msg = __('of which 1 gift product')
                } else {
                    sticker_msg = __('of which %s gift products', qty_free)
                }
                break;
            default:
                sticker_msg = __('gift product')
        }

        return (
            <span>{ sticker_msg } </span>
        )
    }

    renderItems() {
        const { order: { order_products = [] }, currency_code } = this.props;

        return order_products.map((product, i) => {
            const {
                name,
                thumbnail,
                id,
                qty,
                row_total,
                free_gift_item
            } = product;

            const { url } = thumbnail || {};

            return (
                <tr
                    key={ id || i.toString() }
                    block="RetryPageOrderDetails"
                    elem="Row"
                >
                    <td>
                        { url && (
                            <Image
                                src={ url }
                                alt={ name }
                                mix={ { block: 'MyAccountOrderPopup', elem: 'Thumbnail' } }
                            />
                        ) }
                    </td>
                    <td>
                        <p>{ name }</p>
                        { free_gift_item !== '0' && this.renderGiftSticker(free_gift_item, qty) }
                    </td>
                    <td>{ qty }</td>
                    <td>{ `${row_total} ${formatCurrency(currency_code)}` }</td>
                </tr>
            );
        });
    }

    renderProducts() {
        return (
            <div block="RetryPageOrderDetails" elem="ProductsWrapper">
                <h4>{ __('Items Ordered') }</h4>
                <div block="RetryPageOrderDetails" elem="ProductsScroll">
                    <table
                        block="RetryPageOrderDetails"
                        elem="Products"
                    >
                        <thead>
                        <tr>
                            <th>{ __('Image') }</th>
                            <th>{ __('Name') }</th>
                            <th>{ __('Quantity') }</th>
                            <th>{ __('Total') }</th>
                        </tr>
                        </thead>
                        <tbody>
                        { this.renderItems() }
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    renderContent() {
        const { order: { order_products } } = this.props;

        if (!order_products) {
            return null;
        }

        const { order: { base_order_info } } = this.props;
        const { increment_id } = base_order_info || {};

        return (
            <>
                <h3>{__('Retry the payment for the following order:')} { increment_id }</h3>
                { this.renderBaseInfo() }
                { this.renderShipping() }
                { this.renderProducts() }
                { this.renderTotals() }
            </>
        );
    }

    renderSubTotal() {
        const { order: { base_order_info }, currency_code } = this.props;
        const { sub_total } = base_order_info || {};

        return (
            <>
                <dt>{ __('Products cost') }</dt>
                <dd>{ `${sub_total} ${formatCurrency(currency_code)}` }</dd>
            </>
        )
    }

    renderTotalDiscount() {
        const { order: { base_order_info: { total_discount_amount } }, currency_code } = this.props;

        if (!total_discount_amount || total_discount_amount === "0.00") {
            return null;
        }

        return (
            <>
                <dt>{ __('Total discount') }</dt>
                <dd>{ `${total_discount_amount} ${formatCurrency(currency_code)}` }</dd>
            </>
        )
    }

    renderDiscounts() {
        const { order: { base_order_info: { discount_data } }, currency_code } = this.props;

        if (!discount_data) {
            return null;
        }

        return (
            discount_data.map((discount, index) => (
                <Fragment key={ index }>
                    <dt style={{ paddingLeft: 25 }}>{ discount.label }</dt>
                    <dd>{ `${discount.amount} ${formatCurrency(currency_code)}` }</dd>
                </Fragment>
            ))
        )
    }

    renderShippingTotal() {
        const { order: { shipping_info }, currency_code } = this.props;

        const { shipping_amount } = shipping_info || {};

        return (
            <>
                <dt>{ __('Shipping') }</dt>
                <dd>{ `${shipping_amount} ${formatCurrency(currency_code)}` }</dd>
            </>
        )
    }

    renderGrandTotal() {
        const { order: { base_order_info }, currency_code } = this.props;
        const { grand_total } = base_order_info || {};

        return (
            <>
                <dt><strong>{ __('Order Total') }</strong></dt>
                <dd><strong>{ `${grand_total} ${formatCurrency(currency_code)}` }</strong></dd>
            </>
        )
    }

    renderTotals() {
        return (
            <dl block="RetryPageOrderDetails" elem="OrderWrapper">
                { this.renderSubTotal() }
                { this.renderTotalDiscount() }
                { this.renderDiscounts() }
                { this.renderShippingTotal() }
                { this.renderGrandTotal() }
            </dl>
        );
    }

    render () {
        const { onProcessRetryPayment, payu, isLoading, isOrderAllowed } = this.props;
        return (
            <main block="RetryPage">
                <div block="OrderDetails" elem="Content">
                    <Loader isLoading={ isLoading } />
                    { this.renderContent() }
                    { isLoading ? null : (isOrderAllowed ? <button mix={ { block: 'Button OrderDetails', elem:'RetryButton' } }
                                             onClick={ () => onProcessRetryPayment() }>{ __('Retry Payment') }</button> : <p>{__('Payment link is no longer valid or an error occurred')}</p>) }
                </div>

                <div>
                    <PayU payu={payu}></PayU>
                </div>
            </main>
        );
    }
}
export default RetryPayuPage;
